import { MicrositeCTAUI } from "./components/MicrositeCTA/MicrositeCTAUI";
import { IntegratedCTAUI } from "./components/IntegratedCTA/IntegratedCTAUI";
import { useState } from "react";
import TradeInModal from "./components/TradeInModal/TradeInModal";
import classNames from "classnames/bind";
import styles from "./TradeIn.module.scss";

const cx = classNames.bind(styles);

type Props = {
  dispatchTradeInStartedAnalytics: () => void;
  hasMultipleTradeInRoutes: boolean;
  isFullWidthMode: boolean;
};

export const TradeInUI = ({
  dispatchTradeInStartedAnalytics,
  hasMultipleTradeInRoutes,
  isFullWidthMode,
}: Props) => {
  const [isTradeInModelLoading, setTradeInModelLoading] =
    useState<boolean>(false);
  const [isTradeInModelOpen, setTradeInModelOpen] = useState<boolean>(false);
  const integratedOnClick = () => {
    dispatchTradeInStartedAnalytics && dispatchTradeInStartedAnalytics();
    setTradeInModelLoading(true);
    setTradeInModelOpen(true);
  };

  const modalOnClose = () => {
    setTradeInModelOpen(false);
    setTradeInModelLoading(false);
  };

  return (
    <div
      data-component="TradeIn"
      className={cx({ fullWidthMode: isFullWidthMode })}
    >
      {hasMultipleTradeInRoutes && (
        <>
          <IntegratedCTAUI
            isFullWidthMode={isFullWidthMode}
            isTradeInModelLoading={isTradeInModelLoading}
            onClick={integratedOnClick}
          />
          <TradeInModal
            isOpen={isTradeInModelOpen}
            onClose={modalOnClose}
            onFetchQuotesComplete={() => setTradeInModelLoading(false)}
            setTradeInModelOpen={setTradeInModelOpen}
          />
        </>
      )}
      <MicrositeCTAUI
        isFullWidthMode={isFullWidthMode}
        hasMultipleTradeInRoutes={hasMultipleTradeInRoutes}
      />
    </div>
  );
};
